import { SketchLogo } from '@phosphor-icons/react';

export default SketchLogo;
